import React, {forwardRef} from 'react';
import {getElementAttributes} from 'helpers';
import css from './list.module.scss';

export const List = forwardRef(({ className, ...props }, ref) =>
  <div {...getElementAttributes(props)} ref={ref} className={css('list', props, className)} aria-roledescription="list">
    { props.children }
  </div>
);

export function BulletList(props) {
  return (
    <ul {...props} className={css('bullet-list', props)} />
  );
}

List.Title = function Title(props) {
  return (
    <div className={css('title', props)}>{ props.children }</div>
  );
}

List.Group = function Group(props) {
  return (
    <div className={css('group', props)}>{ props.children }</div>
  );
}
